import React, { useState, useEffect, useMemo } from "react";
import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { base64Decode } from "../helperJs/encoderanddecoder";
import GetGuestData from "../confrigration/getGuestData";
import GetGuestLocalData from "../confrigration/getGuestLocalData";
import "../Mycomponent/css/guestlayout.scss";
import Header from "./GuestLink/header";
import Loader from "../Mycomponent/share/loader";
import expiredLinkImg from "./GuestLink/assets/image/expired-link.png";
import axios from "axios";
import { GET_IS_GUEST_LINK_VALID } from "./GuestLink/assets/services";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../Mycomponent/share/components/spinner";
import { ZustandStore } from "../store/zustand-store";
import { AITrackerStore } from "../store/AITrackerStore";
import GetGuestAITrackerData from "../confrigration/getGuestAITrackerData";

const GuestLayout = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { ISPROJECT, mapshowloader } = ZustandStore((state) => state);
  const { ISPROJECT: isAIProject, mapshowloader: isAILOADER } = AITrackerStore(
    (state) => state
  );
  const [urlConfig, setUrlConfig] = useState({
    loading: true,
    error: false,
    photo: "0",
  });

  const showLoader = useSelector((state) => state.showloader);
  const isproject = useSelector((state) => state.isproject);
  const { pathname } = location;

  const localTracker = pathname === "/guest/local-tracker";
  const aiTracker = pathname === "/guest/ai-tracker";

  // Group conditional values in a memoized object
  const { isProject, loader } = useMemo(() => {
    if (localTracker) {
      return { isProject: ISPROJECT, loader: mapshowloader };
    }

    if (aiTracker) {
      return { isProject: isAIProject, loader: isAILOADER };
    }

    return { isProject: isproject, loader: showLoader };
  }, [
    localTracker,
    aiTracker,
    ISPROJECT,
    mapshowloader,
    isAIProject,
    isAILOADER,
    isproject,
    showLoader,
  ]);

  const queryParams = new URLSearchParams(location.search);
  const query_code = queryParams.get("code");
  const domain = queryParams.get("domain");
  const isNew = queryParams.get("in");
  const show_logo_code = queryParams.get("show_logo");
  const logo_code = queryParams.get("logo");
  const show_logo = isNew ? base64Decode(show_logo_code) : show_logo_code;
  const logo = isNew ? base64Decode(logo_code) : logo_code;
  const websiteurl = base64Decode(domain);
  const email = base64Decode(query_code);

  useEffect(() => {
    const curr_url = window.location.href;
    if (curr_url) {
      ZustandStore.setState({
        mapshowloader: true,
      });
      AITrackerStore.setState({
        mapshowloader: true,
      });
      dispatch({ type: "SHOWLOADER", payload: true });
      const encodedLink = encodeURIComponent(curr_url);
      axios
        .get(GET_IS_GUEST_LINK_VALID(encodedLink))
        .then((response) => {
          if (response?.data?.msg === "True") {
            const column = response.data.column;
            ZustandStore.setState({
              rankTableColumn: column === "0" ? [] : column || [],
              mapRankTableColumn: column === "0" ? [] : column || [],
            });
            setUrlConfig({
              loading: false,
              error: false,
              photo: response.data.photo,
            });
          } else {
            setUrlConfig({
              loading: false,
              error: true,
              photo: "0",
            });
          }
        })
        .catch(() => {
          setUrlConfig({
            loading: false,
            error: true,
            photo: "0",
          });
        });
    }
  }, []);

  const renderGuestComponent = () => {
    if (!email || !websiteurl) return null;

    if (localTracker) {
      return <GetGuestLocalData email={email} bussiness_name={websiteurl} />;
    }

    if (aiTracker) {
      return (
        <GetGuestAITrackerData email={email} AITracker_name={websiteurl} />
      );
    }

    return <GetGuestData email={email} websiteurl={websiteurl} />;
  };

  return (
    <React.Fragment>
      <section className="guest-layout-container">
        {renderGuestComponent()}
        <Header logo={logo} showLogo={show_logo} />
        <div className="container">
          {urlConfig?.loading ? (
            <div className="height-no-page">
              <Loader />
            </div>
          ) : loader ? (
            <div className="height-no-page">
              <Spinner />
            </div>
          ) : urlConfig?.error ? (
            <div className="height-no-page">
              <img
                src={expiredLinkImg}
                alt="expired"
                className="expired-image"
              />
            </div>
          ) : (
            <>
              {isProject && !loader ? (
                <Outlet />
              ) : !isProject && !loader ? (
                <div className="height-no-page">
                  <img
                    src={expiredLinkImg}
                    alt="no-proj"
                    className="expired-image"
                  />
                </div>
              ) : (
                <div className="height-no-page">
                  <Spinner />
                </div>
              )}
            </>
          )}
        </div>
      </section>
    </React.Fragment>
  );
};

export default GuestLayout;
